import {
  FETCH_TRACKING_SALE,
  FETCH_SIMILAR_PRODUCTS,
  ShopActionTypes,
  LOADING_ORDER,
  FetchClientData,
  FETCH_MY_ORDERS,
} from "./types";
import type { OrderSimilarProducts } from "../reducers/orderReducer";
import axios from "axios";
import { Dispatch } from "react";
import { PUBLIC_URL } from "../serviceWorker";

export const fetchMyOrders =
  (request: FetchClientData) => async (dispatch: Dispatch<ShopActionTypes>) => {
    dispatch({
      type: LOADING_ORDER,
    });
    await axios
      .get(
        `${PUBLIC_URL}api/shop/fetch_my_orders/${request.cell_phone}/${request.client_id}`,
      )
      .then((response: any) =>
        dispatch({
          type: FETCH_MY_ORDERS,
          payload: response.data,
        }),
      )
      .catch((error: any) => console.log(error));
  };

export const fetchTrackingSale =
  (request: { saleId: string; clientId: string }) =>
  async (dispatch: Dispatch<ShopActionTypes>) => {
    dispatch({
      type: LOADING_ORDER,
    });
    await axios
      .get(
        `${PUBLIC_URL}api/shop/fetch_tracking_sale/${request.saleId}/${request.clientId}`,
      )
      .then((response: any) =>
        dispatch({
          type: FETCH_TRACKING_SALE,
          payload: response.data,
        }),
      )
      .catch((error: any) => console.log(error));
  };

export const fetchSimilarProducts =
  (productName: string) =>
  async (
    dispatch: (action: { type: string; payload: OrderSimilarProducts }) => void,
  ) => {
    dispatch({
      type: FETCH_SIMILAR_PRODUCTS,
      payload: { productName, similarProducts: [], loading: true },
    });
    try {
      const response = await axios.get(
        PUBLIC_URL + `api/products/${productName}/similar`,
      );
      dispatch({
        type: FETCH_SIMILAR_PRODUCTS,
        payload: {
          productName,
          similarProducts: response.data.similarProducts || [],
          loading: false,
        },
      });
    } catch (error) {
      dispatch({
        type: FETCH_SIMILAR_PRODUCTS,
        payload: {
          productName,
          similarProducts: [],
          loading: false,
        },
      });
      console.log(error);
    }
  };

export const clearSimilarProducts = () => ({
  type: "CLEAR_SIMILAR_PRODUCTS",
});

export const addSwap = (payload: {
  saleId?: string;
  saleDetailId: string;
  productId: string;
  quantity: number;
  originalQuantity: number;
  newProductDescription: string;
  originalProductDescription: string;
}) => ({
  type: "ADD_SWAP",
  payload,
});

export const clearSwaps = () => ({
  type: "CLEAR_SWAPS",
});

export const swapProductsOrder = (data: any) => async (dispatch: any) => {
  dispatch({ type: "SWAP_PRODUCTS_ORDER_REQUEST" });
  try {
    await axios.post(PUBLIC_URL + "api/shop/swap_products_order", data);
    dispatch({ type: "SWAP_PRODUCTS_ORDER_SUCCESS" });
    dispatch(clearSwaps());
    dispatch(clearSimilarProducts());
  } catch (error) {
    dispatch({ type: "SWAP_PRODUCTS_ORDER_FAILURE" });
    console.error(error);
  }
};
